// extracted by mini-css-extract-plugin
export default {"visuallyhidden":"message-form-container__visuallyhidden--YTAEz","focusable":"message-form-container__focusable--B9O9R","text":"message-form-container__text--MEPjy"};